import React, { Component } from 'react'

// Redux
import { connect } from 'react-redux'

// Firebase
import * as firebase from 'firebase';
import FirebaseUserManager from './FirebaseUserManager'
import FirebaseTeamsManager from './FirebaseTeamsManager'
import FirebaseChatsManager from './FirebaseChatsManager'
import FirebaseCalendarDays from './FirebaseCalendarDays'
import FirebaseCalendarEvents from './FirebaseCalendarEvents'
import FirebaseGcalSettingsManager from './FirebaseGcalSettingsManager'

class FirebaseManager extends Component {

  componentDidMount() {
    // Update the authenticated userId
    firebase.auth().onAuthStateChanged((user) => {
      const userId = user && user.uid;

      // Update redux
      this.props.dispatch({
        type: 'FIREBASE_AUTH',
        userId: userId
      });
    });

    // Listen for clockOffset
    var offsetRef = firebase.database().ref(".info/serverTimeOffset");
    offsetRef.on("value", snap => {
      var offset = snap.val();
      // Update redux
      this.props.dispatch({
        type: 'FIREBASE_CLOCK_OFFSET',
        value: offset
      });
    });
  }

  render() {
    return (
      <div>
        <FirebaseUserManager />
        <FirebaseTeamsManager />
        <FirebaseChatsManager />
        {/* Schedule */}
        <FirebaseCalendarDays />
        <FirebaseCalendarEvents />
        <FirebaseGcalSettingsManager />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    userAuth: state.firebase.userAuth
  }
}

export default connect(mapStateToProps)(FirebaseManager)



// WEBPACK FOOTER //
// ./src/infra/components/FirebaseManager.js